import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GrupoFamiliar } from './grupo-familiar';
import { GrupoFamiliarService } from './grupo-familiar.service';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material';

@Component({
  templateUrl: './grupo-familiar-list-selection.component.html',
	selector: 'grupo-familiar-list-selection',
})
export class GrupoFamiliarListSelectionComponent implements OnInit {
    @Input()  idEstudo : number;
    @Output() membrosSelecionados: EventEmitter<number[]> = new EventEmitter<number[]>();

    public isLoading: boolean;
    public lista : GrupoFamiliar[];
    public selectedOptions: number[];


    constructor(private grupoFamiliarService: GrupoFamiliarService,
      private mensagem: MatSnackBar,
      public dialog: MatDialog)  {
    }

    ngOnInit() {
      this.buscar();
    }

    buscar(){
      this.isLoading= true;
      let filtro: GrupoFamiliar = new GrupoFamiliar;
      filtro.codigoEstudoSocioEconomico = this.idEstudo;
      this.grupoFamiliarService.filtrar(filtro).subscribe(
        (result:GrupoFamiliar[]) => {
          if(result.length == 0) {
            this.selecionar();
          }else{
            this.lista = result;
            this.selectedOptions = new Array<number>();
            this.lista.forEach(x => this.selectedOptions.push(x.id));
          }
          this.isLoading= false;
        },  error =>  this.erro(error)
      );
    }

    // Emite a row rowSelecionada
    public selecionar(){
      this.membrosSelecionados.emit(this.selectedOptions);
    }

  // mostra erros na tela
   private erro(erro: string): void{
    this.mensagem.open(erro, 'X', {duration: 5000});
    this.isLoading= false;
  }


}
